import { withScrolledInView } from "@studiometa/js-toolkit";
import { AbstractScrollAnimation } from "./AbstractScrollAnimation.js";
class ScrollAnimation extends withScrolledInView(AbstractScrollAnimation, {}) {
  /**
   * Config.
   */
  static config = {
    ...AbstractScrollAnimation.config,
    name: "ScrollAnimation",
    refs: ["target"]
  };
  /**
   * Use the `target` ref as animation target.
   */
  get target() {
    return this.$refs.target;
  }
}
export {
  ScrollAnimation
};
//# sourceMappingURL=ScrollAnimation.js.map
